// Toast service for showing notifications outside of React components
let enqueueSnackbarRef = null;

export const setSnackbarRef = (enqueueSnackbar) => {
  enqueueSnackbarRef = enqueueSnackbar;
};

export const toast = {
  success: (message, options = {}) => {
    enqueueSnackbarRef?.(message, { variant: "success", ...options });
  },
  error: (message, options = {}) => {
    enqueueSnackbarRef?.(message, { variant: "error", ...options });
  },
  warning: (message, options = {}) => {
    enqueueSnackbarRef?.(message, { variant: "warning", ...options });
  },
  info: (message, options = {}) => {
    enqueueSnackbarRef?.(message, { variant: "info", ...options });
  },
};
